import cx                           from 'classnames';
import React, { PropTypes }         from 'react';
import { connect }                  from 'reflux';
import { get }                      from 'lodash';

import { isMobile, isIpad }         from 'utils/util';

import TogglesPlay                  from 'mixins/toggles_play';

import DescriptorStore              from 'stores/descriptor_store';
import VideoStore                   from 'stores/video_store';

import PlayerControls               from 'components/player/controls';
import PlayerScreen                 from 'components/player/screen';
import EpisodeGuide                 from 'components/medscape_tv/episode_guide';
import ProgressBar                  from 'components/player/progress_bar';


export default React.createClass({
  displayName: 'StandalonePlayer',
  propTypes: {
                id: PropTypes.string,
    descriptorJSON: PropTypes.object,
        onVideoEnd: PropTypes.func,
        videoIndex: PropTypes.number,
             hasCC: PropTypes.bool,
  videoUrlFragment: PropTypes.string,
       isMouseIdle: PropTypes.bool
  },
  mixins: [ connect(DescriptorStore), connect(VideoStore), TogglesPlay ],
  getDefaultProps() {
    return {
      videoElementId: 'medscape-akamai-video-container',
         isMouseIdle: false
    };
  },
  getInitialState() {
    return { video: { } };
  },
  componentWillMount() {

  },
  shouldComponentUpdate(nextProps, nextState) {
    if(nextState.video.currentTime !== this.state.video.currentTime) {
      return true;
    }
    if(nextProps.isMouseIdle !== this.props.isMouseIdle) {
      return true;
    }
    if(nextProps.videoIndex !== this.props.videoIndex) {
      return true;
    }
    if(this.props.videoUrlFragment !== nextProps.videoUrlFragment) {
      return true;
    }
    const descriptor = this.state.descriptor, video = nextState.video;
    if(video.event === 'ended') {
      if(this.props.onVideoEnd) this.props.onVideoEnd(video.index);
    }

    return (nextState.descriptor !== descriptor                            ||
            nextState.video.isFullScreen !== this.state.video.isFullScreen ||
            nextState.video.isLoading !== this.state.video.isLoading       ||
            nextState.video.isPlaying !== this.state.video.isPlaying);
  },
  getVideoIndex(videoUrlFragment) {
    return this.props.descriptorJSON.videos.findIndex(video => video.videoUrlFragment === videoUrlFragment);
  },
  renderControls() {
    if(isMobile() && !isIpad()) {
    const media       = this.state.video || { isBuffering: true },
          currentTime = media.currentTime;
      return (<ProgressBar {...media}
                    currentTime={currentTime}
                    hasProgress={true}
                    hasScrub={false}
                    hasLength={false} />);
    } else {
      return (<PlayerControls
                playerId={this.props.id}
                hasCC={this.props.hasCC} />);
    }
  },
  render() {
    let controls, screenComponent = (<div className="video-player-empty-shell">loading. . .</div>);
    const       descriptor = this.state.descriptor,
          { isFullScreen } = this.state.video,
                 isPlaying = get(this, 'state.video.isPlaying', false),
                hasStarted = get(this, 'state.video.hasStarted', false);
    if(descriptor) {
      const videoIndex = this.getVideoIndex(this.props.videoUrlFragment),
            classNames = cx({
              'video-player-standalone': true,
                        'is-fullscreen': isFullScreen,
                           'is-playing': isPlaying,
                              'is-idle': this.props.isMouseIdle
            });
      if(videoIndex !== -1) {
        if(document.querySelector('.hero-bg') !== null) {
          document.querySelector('.hero-bg').style.display = 'none';
        }
        const video = descriptor.videos[videoIndex],
        watermark = get(video, 'options.watermark', null);
        screenComponent = (<div className={classNames} id={this.props.id}>
                  <PlayerScreen
                            onTouchEnd={this.start}
                            isPlaying={isPlaying}
                            hasStarted={hasStarted}
                            shouldShowNativeControls={!controls}
                            watermark={watermark}
                            videoElementId="medscape-akamai-video-container"
                            videoIndex={videoIndex}
                            video={video} />
                  { this.renderControls() }
               </div>);
      } else {
        if(document.querySelector('.hero-bg') !== null) {
          document.querySelector('.hero-bg').style.display = 'block';
        }
        screenComponent = (<div className={classNames} id={this.props.id}>
                             <EpisodeGuide />
                          </div>);
      }
    }
    return screenComponent;
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/standalone_player.jsx
 **/